import { render } from "./CookiesDashCard.vue?vue&type=template&id=670f833b&scoped=true&ts=true"
import script from "./CookiesDashCard.vue?vue&type=script&lang=ts"
export * from "./CookiesDashCard.vue?vue&type=script&lang=ts"

import "./CookiesDashCard.vue?vue&type=style&index=0&id=670f833b&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670f833b"]])

export default __exports__